import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppRoutes } from 'src/app/app-routes';
import { SubmittableForm } from 'src/app/models/base/submittable-form.base';
import { RegisterService } from 'src/app/services/register-service/register.service';

export enum RouteParams {
  PHONE = 'phone',
  CODE = 'code'
}

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent extends SubmittableForm {

  faBack = faArrowLeft;
  AppRoutes = AppRoutes;

  userNumber: number;
  verifyCode: string;

  constructor(
    translationService: TranslateService, 
    private activeRoute: ActivatedRoute, 
    private spinner: NgxSpinnerService, 
    private registerService: RegisterService,
    private router: Router
    ) 
  { 
    super(translationService)

    this.userNumber = this.activeRoute.snapshot.params && this.activeRoute.snapshot.params[RouteParams.PHONE];
    this.verifyCode = this.activeRoute.snapshot.params && this.activeRoute.snapshot.params[RouteParams.CODE];
  }

  override form = new FormGroup({
    password: new FormControl('', {
      validators: [Validators.required, Validators.minLength(6)]
    }),
    confirm: new FormControl('', {
      validators: [Validators.required, Validators.minLength(6), this.matchesValueFrom('password')]
    })
  });


  async onPasswordSubmitted()
  {
    this.spinner.show();

    const loginID = `${this.userNumber}`;

    return super.onConfirm(
      () => this.registerService.sendNewPassword(loginID, this.verifyCode, (this.form.value?.password as string)),
      {
        onSuccess: () => {
          this.spinner.hide();

          this.router.navigateByUrl(AppRoutes.Details);
        },
        onError: () => {
          this.spinner.hide();
        }
    });
  }

  shouldAllowReset(): boolean
  {
    return this.form.invalid;
  }

}
